import React from 'react';
import Box from 'Components/Atoms/Box';
import SwitchBox from 'Components/Atoms/Switch';
import Typography from 'Components/Atoms/Typography';
import { Event } from 'types/calendar';
import useTicketDoorApp from 'App/TicketDoor/useTicketDoorApp';
import TicketMailTextField from './TicketMailTextField';

type QrTicketSettingsProps = {
  restaurantId: string | null;
  eventState: Event;
  setEventState: (event: Event) => void;
};

/**
 * The event's QR-Code switch with its ticket-mail text, part of the free App Store
 * app Ticket-Einlass (BETA): shown only while the app is active for this restaurant.
 * Off or still loading, nothing is shown and nothing is changed — the event keeps
 * its stored QR flag and text for a reactivation.
 */
const QrTicketSettings = ({ restaurantId, eventState, setEventState }: QrTicketSettingsProps) => {
  if (useTicketDoorApp(restaurantId) !== 'active') return null;

  return (
    <>
      <Box flex className="mg-bt-lg event-optional-ticket" style={{ alignItems: 'flex-start' }}>
        <Box className="event-optional-ticket" style={{ marginRight: 8 }}>
          <Typography variant="h5" className="mg-bt-xs" translation="calendar">
            QR-Code
          </Typography>
          <Typography color="subdued" variant="text-3" translation="calendar">
            Do you want to send QR-Codes with your Ticket confirmation that can be scanned in the Restaurant via the
            Gastronaut Mobile App.
          </Typography>
        </Box>
        <SwitchBox
          className="event-switch-width"
          checked={eventState.offerQrCode ?? false}
          onChange={() => {
            setEventState({
              ...eventState,
              offerQrCode: !eventState.offerQrCode,
            });
          }}
          label=""
        />
      </Box>
      {/* The text stays in the event while the switch is off. */}
      {eventState.offerQrCode && (
        <TicketMailTextField
          value={eventState.ticketMailText ?? ''}
          onChange={(ticketMailText) => setEventState({ ...eventState, ticketMailText })}
        />
      )}
    </>
  );
};

export default QrTicketSettings;
